/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import summaryStyle from "./summaryStyle";

type PersonalDataProps = {
  product: AbstractCase;
};
const PersonalData = ({ product }: PersonalDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.gender"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.givenName"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.familyName"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.birthDate"} fieldType={"date"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.streetAddress"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.postalCode"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.addressLocality"} />
      <SummaryDetailsItem caseData={product} fieldPath={"customer.telephone"} />
      <SummaryDetailsItem caseData={product} fieldPath={"customer.contactTime"} />
      <SummaryDetailsItem caseData={product} fieldPath={"maritalStatus"} />
      {product.maritalStatus === "married" && (
        <>
          <SummaryDetailsItem caseData={product} fieldPath={"partnerIsWorking"} />
        </>
      )}
      <SummaryDetailsItem caseData={product} fieldPath={"numberChildren"} />
    </>
  );
};

export default PersonalData;
